
if(typeof acf !== 'undefined') {
    acf.add_filter('color_picker_args', function( args, field ){
        args.palettes = [
            '#71c2bb', 
            '#e42b3d',
            '#7d1e1f',
            '#f5d916',
            '#f5dec8',
            '#afd07b',
        ]
    
        return args;
    });
}